module.exports = __webpack_public_path__ + "static/media/schawkLogo.0841dc3d.png";